/**
 * SIG-1199 / RFC-004 T3 — same 10s bound as backend MARK_MAX_AGE_SECONDS.
 * A mark older than this while Globex is open is stale, never a live P&L.
 */
import type { ClockState } from "@/features/market-session/market-session";

export const MARK_MAX_AGE_SECONDS = 10;

export interface MarkStaleness {
  isStale: boolean;
  ageSeconds: number | null;
}

export function deriveMarkStaleness(
  lastQuoteAtMs: number | null,
  nowMs: number,
  marketState: ClockState,
): MarkStaleness {
  if (lastQuoteAtMs == null) {
    return { isStale: false, ageSeconds: null };
  }
  const ageSeconds = Math.max(0, (nowMs - lastQuoteAtMs) / 1000);
  if (marketState !== "open") {
    return { isStale: false, ageSeconds };
  }
  return { isStale: ageSeconds > MARK_MAX_AGE_SECONDS, ageSeconds };
}

export function formatMarkStaleLabel(ageSeconds: number | null): string {
  if (ageSeconds == null) return "mark stale";
  return `mark stale ${Math.floor(ageSeconds)}s`;
}
